export default function getWbImageUrl(id: number): string {
  const s = Math.floor(id / 100000);
  const part = Math.floor(id / 1000);

  const DEFAULT_BASKET = 21; // As of 12.02.25, total number of baskets: 21, based on WB sources
  const BASKET_STEP = 216; // Last identified "step" for forming new basket boundary, starting from 14-basket(2190)+216=2406+216=2622 etc.
  const BASKET_LIMITS = [
    144, 288, 432, 720, 1008, 1062, 1116, 1170, 1314, 1602, 1656, 1920, 2046,
    2190, 2406, 2622, 2838, 3054, 3270, 3486,
  ] as const;

  let basket: number;
  const foundBasket = BASKET_LIMITS.findIndex((limit) => s < limit);

  if (foundBasket !== -1) {
    basket = foundBasket + 1;
  } else {
    const lastLimit = BASKET_LIMITS[BASKET_LIMITS.length - 1];
    basket =
      DEFAULT_BASKET + Math.floor((s - (lastLimit as number)) / BASKET_STEP);
  }

  const basketStr = basket < 10 ? `0${basket}` : `${basket}`;

  return `https://basket-${basketStr}.wbbasket.ru/vol${s}/part${part}/${id}/images/big/1.webp`;
}
